import { memo } from "react";
import { FormStepperContextProvider } from "../../../store/contexts/FormStepperContext";
import { FormSteps } from "./FormSteps/FormSteps";
import { IFormStepper } from "./models";

export const FormsStepper = memo(
  ({ initialStep, currentActiveStep, steps, endComponent, layoutForm, questions, hasAnswerDate }: IFormStepper) => {
    return (
      <FormStepperContextProvider initialStep={initialStep} currentActiveStep={currentActiveStep}>
        <FormSteps
          endComponent={endComponent}
          steps={steps}
          layoutForm={layoutForm}
          questions={questions}
          hasAnswerDate={hasAnswerDate}
        />
      </FormStepperContextProvider>
    );
  }
);